import api from './api'

const resource = '/branches'

export default {
    get(page, region, q, per_page, is_active) {
        return api.get(`${resource}?page=${page}&region=${region}&q=${q}&per_page=${per_page}&is_active=${is_active}`);
    },
    add(params) {
        return api.post(`${resource}`, params);
    },
    update(code, params) {
        return api.put(`${resource}/${code}`, params);
    },
    getAll(region) {
        return api.get(`${resource}?per_page=100&region=${region}`);
    },
    getPost(slug){
        return api.get(`${resource}?slug=${slug}`);
    }
}